import Breadcrumbs from '@modules/common/components/breadcrumbs';
import Container from '@modules/common/components/container';
import SkeletonProductGrid from '@modules/skeletons/templates/skeleton-product-grid';

export const breadcrumbsItems = [
  { name: '首頁', href: '/' },
  { name: '搜尋結果' },
];

/**
 * Skeleton shown during lazy loading of SearchPage component.
 */
export function SearchPageSkeleton() {
  return (
    <Container className="min-h-[calc(100vh-490px)]">
      <Breadcrumbs items={breadcrumbsItems} className="py-8" />
      <SkeletonProductGrid />
    </Container>
  );
}
